<div class="content col-mg-9 col-lg-12 pt-3">
  <div class="d-flex flex-column justify-content-center align-items-center" style="height: 100vh;">
    <h1>This page is under construction.</h1>
    <i class="mt-3 fas fa-5x fa-cogs"></i>
  </div>
</div>
